export { default } from './log.vue'
